export default "__VITE_ASSET__BxrXJr_X__"